(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["asavya-accordion"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.__asvAccInit)return;window.__asvAccInit=true;
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-acc]');
    if(!btn)return;
    var panel=btn.nextElementSibling;
    if(!panel)return;
    var open=!panel.hidden;
    panel.hidden=open;
    btn.classList.toggle('is-open',!open);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["asavya-cart-drawer"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.AsvCart)return;
  var CUR='EUR';
  var COMPARE={};try{COMPARE=JSON.parse(document.getElementById('asv-variant-compare').textContent)}catch(e){}
  var ADDONS=[];try{ADDONS=JSON.parse(document.getElementById('asv-addon-ids').textContent)||[]}catch(e){}
  var CFG={};try{CFG=JSON.parse(document.getElementById('asv-cart-config').textContent)||{}}catch(e){}
  /* vignette 200px : les visuels sources font parfois plus d'un Mo */
  function thumb(u){return (u&&u.indexOf('cdn.shopify.com')>-1&&u.indexOf('width=')<0)?u+(u.indexOf('?')>-1?'&':'?')+'width=200':u;}
  function isAddonId(id){return ADDONS.indexOf(id)>-1;}
  function money(c){try{return new Intl.NumberFormat('fr-FR',{style:'currency',currency:CUR}).format(c/100);}catch(e){return (c/100).toFixed(2)+' €';}}
  var el=function(id){return document.getElementById(id);};
  var MIN='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var PLU='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var TRASH='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';

  function updateCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(b){
      if(n>0){b.textContent=n;b.style.display='';}else{b.style.display='none';}
    });
  }
  function render(cart){
    CUR=cart.currency||'EUR';
    updateCount(cart.item_count);
    var lbl=el('asv-cart-count-label'); if(lbl)lbl.textContent=cart.item_count>0?' · '+cart.item_count:'';
    var items=(cart.items||[]).filter(function(it){return it.quantity>0;});
    var itemsEl=el('asv-cart-items'),shipEl=el('asv-cart-ship'),footEl=el('asv-cart-foot');
    /* Redessiner la liste remet le defilement a zero et renvoie le client en haut.
       On memorise la position, en prenant le bloc add-ons comme repere fixe : si une
       ligne s'ajoute au-dessus, on compense sa hauteur pour que l'ecran ne bouge pas. */
    var scrollEl=el('asv-cart-scroll'), anchorEl=el('asv-cart-addons');
    var drawerOpen=el('asv-cart').classList.contains('open');
    var prevTop=(drawerOpen&&scrollEl)?scrollEl.scrollTop:0;
    var prevAnchor=(prevTop>0&&anchorEl)?anchorEl.offsetTop:0;
    if(!items.length){
      itemsEl.innerHTML='<div class="asv-cart__empty"><div class="asv-cart__empty-ic">🛒</div><p>Votre panier est vide</p><p class="asv-cart__empty-s">À la maison, en quelques minutes.</p><a href="/products/masseur-ventouse-intelligent" class="asv-cart__empty-cta">Je veux soulager mes tensions</a></div>';
      if(shipEl)shipEl.style.display='none'; if(footEl)footEl.hidden=true;
      var adEmpty=el('asv-cart-addons'); if(adEmpty)adEmpty.hidden=true;
      return;
    }
    if(shipEl)shipEl.style.display='';
    var adEl=el('asv-cart-addons'); if(adEl)adEl.hidden=false;
    var totalOrig=0,totalDevices=0,html='';
    items.forEach(function(it,i){
      var addon=isAddonId(it.variant_id);
      var cu=COMPARE[it.variant_id]||it.compare_at_price||it.final_price;
      var lineOrig=cu*it.quantity, lineFinal=it.final_line_price, sav=lineOrig-lineFinal;
      /* les add-ons gardent leur propre visuel produit ; le masseur utilise celui du panier */
      var src=thumb(addon?it.image:(CFG.mainImage||it.image));
      var img=src?'<img src="'+src+'" alt="" decoding="async">':'';
      var label,sub;
      /* toute ligne compte son ecart prix barre / prix paye : le 2e masseur apporte
         sa remise -40%, la protection n'a pas de prix barre donc apporte 0 */
      totalOrig+=lineOrig;
      if(addon){
        label=it.product_title; sub='';
      }else{
        /* nb d'appareils : pilote la quantite des cadeaux (add-ons exclus) */
        var pack='';
        if(it.options_with_values){it.options_with_values.forEach(function(o){if((o.name||'').toLowerCase()==='pack')pack=o.value;});}
        if(!pack&&it.variant_title){var pp=it.variant_title.split('/');pack=(pp[pp.length-1]||'').trim();}
        var unitsMap={'solo':1,'duo':2,'trio':3},u=unitsMap[pack.toLowerCase()]||1;
        totalDevices+=u*it.quantity;
        label='Masseur Asavya';
        sub=(u*it.quantity)>1?((u*it.quantity)+' appareils'):'';
      }
      html+='<div class="asv-cart__item">'+
        '<div class="asv-cart__thumb">'+img+'</div>'+
        '<div class="asv-cart__body">'+
          '<div class="asv-cart__row1"><div class="asv-cart__titles"><p class="asv-cart__name">'+label+'</p>'+(sub?'<p class="asv-cart__sub2">'+sub+'</p>':'')+'</div>'+
          '<button class="asv-cart__trash" data-line="'+(i+1)+'" data-qty="0" aria-label="Supprimer">'+TRASH+'</button></div>'+
          '<div class="asv-cart__row2">'+
            '<div class="asv-cart__stepper">'+
              '<button data-line="'+(i+1)+'" data-qty="'+(it.quantity-1)+'" aria-label="Moins">'+MIN+'</button>'+
              '<span>'+it.quantity+'</span>'+
              '<button data-line="'+(i+1)+'" data-qty="'+(it.quantity+1)+'" aria-label="Plus">'+PLU+'</button>'+
            '</div>'+
            '<div class="asv-cart__price">'+
              (sav>0?'<p class="asv-cart__was">'+money(lineOrig)+'</p>':'')+
              '<p class="asv-cart__now">'+money(lineFinal)+'</p>'+
              ''+
            '</div>'+
          '</div>'+
        '</div></div>';
    });
    // gifts offered (first example — values mirror the value stack; balle/pochette per device)
    var GIFTS=[{n:'Balle de massage à picots',v:1299,m:true},{n:'Pochette de transport',v:490,m:true},{n:'Guide Anti-Tensions',v:1290,m:false},{n:'Livraison',v:790,m:false}];
    try{var _gj=document.getElementById('asv-gifts-json');if(_gj){var _ga=JSON.parse(_gj.textContent);if(_ga&&_ga.length)GIFTS=_ga;}}catch(e){}
    var giftsValue=0,ghtml='';
    if(totalDevices>0){
      ghtml='<div class="asv-cart__gifts"><div class="asv-cart__gifts-head">Offerts avec votre commande</div><div class="asv-cart__gift-row">';
      GIFTS.forEach(function(g){var q=g.m?totalDevices:1;var val=g.v*q;giftsValue+=val;
        var cls=(g.fond==='photo')?' class="is-photo"':'';
        var st=[];if(g.zoom&&g.zoom!=1)st.push('transform:scale('+g.zoom+')');if(g.lum&&g.lum!=1)st.push('filter:brightness('+g.lum+')');
        var vis=g.img?'<img src="'+g.img+'" alt=""'+cls+(st.length?' style="'+st.join(';')+'"':'')+'>':'';
        ghtml+='<div class="asv-cart__gift"><span class="asv-cart__gift-tile">'+vis+'</span><span class="asv-cart__gift-l">'+(g.court||g.n)+(q>1?' ×'+q:'')+'</span></div>';
      });
      ghtml+='</div></div>';
    }
    itemsEl.innerHTML=html+ghtml;
    var totalFinal=cart.total_price;
    var valeurTotale=totalOrig+giftsValue;
    var economie=valeurTotale-totalFinal;
    el('asv-cart-total-now').textContent=money(totalFinal);
    var btnTot=el('asv-cart-checkout-total');if(btnTot)btnTot.textContent=money(totalFinal);
    var trust=el('asv-cart-trust');if(trust)trust.hidden=false;
    var wasEl=el('asv-cart-total-was'),remRow=el('asv-cart-remise-row');
    if(economie>1){wasEl.textContent=money(valeurTotale);el('asv-cart-remise').textContent='−'+money(economie);remRow.style.display='';}
    else{wasEl.textContent='';el('asv-cart-remise').textContent='';remRow.style.display='none';}
    syncAddons(items);
    if(footEl)footEl.hidden=false;
    if(prevTop>0&&scrollEl){
      var delta=anchorEl?(anchorEl.offsetTop-prevAnchor):0;
      scrollEl.scrollTop=prevTop+delta;
    }
  }

  /* Etat des add-ons = etat reel du panier. La case n'est cochee que si la ligne
     existe deja, c'est-a-dire uniquement apres une action du client. */
  function findLine(items,vid){
    for(var i=0;i<items.length;i++){if(items[i].variant_id===vid)return i+1;}
    return 0;
  }
  function syncAddons(items){
    document.querySelectorAll('[data-addon]').forEach(function(a){
      var line=findLine(items,parseInt(a.getAttribute('data-vid'),10));
      a.setAttribute('data-line',line||'');
      a.classList.toggle('is-in',!!line);
      var btn=a.querySelector('[data-addon-btn]');
      if(btn)btn.textContent=line?'Retirer':'Ajouter';
      var cb=a.querySelector('[data-addon-cb]');
      if(cb)cb.checked=!!line;
    });
  }
  function fetchCart(cb){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){render(c);if(cb)cb(c);return c;}).catch(function(){});}
  function open(){var c=el('asv-cart');c.classList.add('open');c.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
  function close(){var c=el('asv-cart');c.classList.remove('open');c.setAttribute('aria-hidden','true');document.body.style.overflow='';}
  var busy=false;
  function add(id,qty){
    if(busy)return; busy=true;
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})})
      .then(function(r){return r.json();})
      /* on attend le rendu avant d'ouvrir : sinon le tiroir s'affiche vide,
         avec pour seul contenu le bloc add-ons qui est du HTML statique */
      .then(function(){return fetchCart();})
      .then(function(){open();},function(){open();})
      .catch(function(){fetchCart();}).then(function(){busy=false;});
  }
  function change(line,qty){
    if(busy)return; busy=true;
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json();}).then(function(c){
        if(c&&c.items){render(c);}else{fetchCart();} /* on error, re-sync instead of showing empty */
      }).catch(function(){fetchCart();}).then(function(){busy=false;});
  }
  window.AsvCart={open:open,close:close,refresh:fetchCart,add:add,change:change};

  document.addEventListener('DOMContentLoaded',function(){fetchCart();});

  /* delegate clicks: close, toggle, stepper/trash */
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-close]')){close();return;}
    if(e.target.closest('[data-cart-toggle]')){e.preventDefault();open();return;}
    /* add-ons (upsell + order bumps) : ajout/retrait sur clic explicite du client */
    var ab=e.target.closest('[data-addon-btn]');
    if(ab){
      e.preventDefault();
      var wrap=ab.closest('[data-addon]');
      var aline=parseInt(wrap.getAttribute('data-line'),10);
      if(aline>0){change(aline,0);}else{add(parseInt(wrap.getAttribute('data-vid'),10),1);}
      return;
    }
    var step=e.target.closest('.asv-cart__stepper button, .asv-cart__trash');
    if(step){var line=parseInt(step.getAttribute('data-line')),q=parseInt(step.getAttribute('data-qty'));change(line,q<0?0:q);return;}
    /* ATC: click-based (NOT a /cart/add form submit) so Shopify counts the add only once */
    var atc=e.target.closest('.asv-atc');
    if(atc){
      e.preventDefault();
      var form=atc.closest('form.asv-bundle');
      if(form){
        var id=form.querySelector('[name=id]').value;
        var qf=form.querySelector('[name=quantity]');
        var qty=qf?parseInt(qf.value)||1:1;
        add(id,qty);
      }
      return;
    }
  });
  /* safety net: if a .asv-bundle form ever submits (no-JS edge), block native nav */
  document.addEventListener('submit',function(e){
    if(e.target.closest('form.asv-bundle')){e.preventDefault();}
  });
  /* Option a cocher (garantie) : l'add-on n'entre au panier QUE si le client coche
     lui-meme la case. Aucune pre-selection, aucun ajout automatique. */
  document.addEventListener('change',function(e){
    var cb=e.target.closest('[data-addon-cb]');
    if(!cb)return;
    var wrap=cb.closest('[data-addon]');
    var cline=parseInt(wrap.getAttribute('data-line'),10);
    if(cb.checked){
      if(!(cline>0))add(parseInt(wrap.getAttribute('data-vid'),10),1);
    }else{
      if(cline>0)change(cline,0);
    }
  });
  /* esc to close */
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["asavya-featured-review"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.__asvFeatInit)return;window.__asvFeatInit=true;
  function stars(n){return '★★★★★☆☆☆☆☆'.slice(5-n,10-n);}
  document.addEventListener('DOMContentLoaded',function(){
    var dataEl=document.getElementById('asv-featured-json');
    var data=[];try{data=JSON.parse(dataEl.textContent)}catch(e){}
    document.querySelectorAll('[data-feat]').forEach(function(box){
      var i=0;
      var img=box.querySelector('[data-feat-img]');
      var nm=box.querySelector('[data-feat-name]');
      var st=box.querySelector('[data-feat-stars]');
      var tx=box.querySelector('[data-feat-text]');
      var nx=box.querySelector('[data-feat-next]');
      function render(){
        if(!data.length)return;
        var r=data[i%data.length];
        if(img&&r.image)img.src=r.image;
        if(nm)nm.textContent=r.name;
        if(st)st.textContent=stars(r.rating||5);
        if(tx)tx.textContent='"'+r.text+'"';
      }
      if(nx)nx.addEventListener('click',function(){i++;render();});
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
